// extracted by mini-css-extract-plugin
export default {"tierlist":"TierList_tierlist__Gu5za"};